module.exports = __webpack_public_path__ + "img/9788963717562.3edd3903.jpg";